module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/question-2d4272ce9ada949b9629a4b1a62a2cce.svg";